export default __webpack_public_path__ + "static/media/AM_00797 copy.7300c898.jpg";